import { Tabs } from 'element-ui'
import './style.scss'

const YTabs = Tabs
YTabs.$depends = [Tabs]
YTabs.$name = 'y-tabs'
YTabs._name = 'Tabs 标签页'

export default YTabs
